import { render, staticRenderFns } from "./Montos.vue?vue&type=template&id=3fe16a4a&scoped=true"
import script from "./Montos.vue?vue&type=script&lang=js"
export * from "./Montos.vue?vue&type=script&lang=js"
import style0 from "./Montos.vue?vue&type=style&index=0&id=3fe16a4a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe16a4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fe16a4a')) {
      api.createRecord('3fe16a4a', component.options)
    } else {
      api.reload('3fe16a4a', component.options)
    }
    module.hot.accept("./Montos.vue?vue&type=template&id=3fe16a4a&scoped=true", function () {
      api.rerender('3fe16a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/infoBase/Montos.vue"
export default component.exports